import { Button } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import TextInput from "components/forms/TextInput";
import { useForm } from "react-hook-form";
import { signup } from "services/user";
import { useBackendError } from "services/hooks";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setActiveDialog, setUser } from "store/app";
import { DialogType } from "store/app/types";
import { useSnackbar } from "notistack";

const SignUp = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    reset
  } = useForm();
  const dispatch = useAppDispatch();
  const { dialog } = useAppSelector((state) => state.app);
  const { handleRequestError } = useBackendError();
  const { enqueueSnackbar } = useSnackbar();

  const submit = async (form) => {
    const { email, password } = form;
    try {
      const response = await signup(email,password);
      dispatch(setUser(response));
      enqueueSnackbar("Welcome! You were successfully logged in.", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
      handleClose();
    } catch(err) {
      handleRequestError(err);
    }
  }

  const handleDialogSwitch = () => {
    dispatch(setActiveDialog(DialogType.Login));
  }

  const handleClose = () => {
    reset({
      email:'',
      password:''
    });
    dispatch(setActiveDialog(null));
  }
  
  return (
    <DialogWrapper
      title="Create New Account"
      isOpen={dialog === DialogType.Signup}
      onClose={handleClose}
      onDialogClose={handleClose}
      footer={false}
    >
      <>
        <form onSubmit={handleSubmit(submit)}>
          <TextInput
            control={control}
            name="email" 
            label="E-mail"
            errors={errors}
            rules={{
              required: "This field is required",
              pattern: {
                value: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
                message: "Invalid email address",
              },
            }}
          />
          <TextInput
            control={control}
            name="password" 
            label="Password"
            errors={errors}
            type="password"
            rules={{
              required: "This field is required",
              minLength: {
                value: 5,
                message: "Password must have at least 5 characters.",
              },
            }}
          />
          <TextInput
            control={control}
            name="confirm_password" 
            label="Confirm Password"
            errors={errors}
            type="password"
            rules={{
              validate: (value) => {
                return (
                  value === watch("password") || "Your passwords must match."
                );
              },
            }}
          />
          <div className="d-flex justify-content-end">
            <Button variant="outlined" size="small" className="me-3" onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="contained" size="small">Submit</Button>
          </div>
          <div className="mt-3 text-center">
            <Button variant="text" onClick={handleDialogSwitch}>
              Already have an account?
            </Button>
          </div>
        </form>
      </>
    </DialogWrapper>
  );
};

export default SignUp;
